'use strict';

function parseTime ( time ) {
    var min, sec, hour;

    if ( !time ) {
        return '0:00';
    }

    hour = Math.floor(time / 3600);
    min = Math.floor((time - (hour * 3600)) / 60);
    sec = time - (hour * 3600) - (min * 60);

    return (hour ? hour + ':' : '') +
        (min ? (hour && min > 9 ? min : '0' + min) + ':' : '0:') +
        (sec > 9 ? sec : '0' + sec);
}

/**
 * Change server data to list data for tracks.
 *
 * @param {Array} data - response from server
 *
 * @return {Array} prepared data for LayoutList
 */
module.exports = function ( data ) {
    var result = [],
        index;

    if ( data && data.length ) {
        for ( index = 0; index < data.length; index++ ) {
            result[index] = {
                items: [
                    {
                        className: 'title',
                        value: data[index].name
                    },
                    {
                        className: 'time',
                        value: parseTime(data[index].duration)
                    }
                ],
                value: data[index]
            };
        }
    }

    return result;
};
